import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  // Form,
  Control,
  actions
  // Errors
} from 'react-redux-form';
import { Redirect } from 'react-router-dom'
import Loading from './Loading';
import {
  create_project,
  reset_feed_errors
 } from '../actions'
import Errors from './Errors'
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const { toast } = window.M
const mapStateToProps = state => {
  return {
    // form: state.forms.login,
    mustRedirect: state.feed.mustRedirect,
    feed: state.feed.feed,
    errors: state.feed.errors
  };
}

const mapDispatchToProps = dispatch => {
  return {
    createProject: values => dispatch(create_project(values)),
    resetForm: () => dispatch( actions.reset('newProject') ),
    resetErrors: () => dispatch ( reset_feed_errors() )
  };
}

class ConnectedNewProject extends React.Component {
  constructor() {
    super()
    this.state = {
      basichttp: false,
      feed_type: 'xml',
      feed_file: '',
      file: null
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch
  }

  handleUpdate(form) {
    const {feed_type} = form
    this.setState({
      feed_type: feed_type.value
    })
  }

  handleChangeFile(e) {
    console.log("e")
    console.log(e.target.files[0])
    // this.formDispatch(actions.change('newProject.file', e.target.files[0]))
    this.setState({file: e.target.files[0], feed_file: e.target.files[0].name})
  }


	handleSubmit(values) {
    console.log("values")
    console.log(values)
    const { file, ...other } = values
    if (values.feed_type !== 'textfile' && values.feed_type !== 'excelfile') {
      this.props.createProject(other)
    } else {
      if ( file && file[0] && file[0].name ) {
        const theFile = this.state.file
        const { name, feed_type } = values
        let formData = new FormData()
        formData.append( "name", name )
        formData.append( "feed_type", feed_type )
        formData.append( "file", theFile, theFile.name )
        this.props.createProject(formData)
        // console.log(formData)
      } else {
        toast({ html: "Please, select a file to upload"})
      }
    }
	}

  componentWillUnmount() {
    this.props.resetForm()
    this.props.resetErrors()
  }

  toggleBasicHttp() {
    const {basichttp} = this.state
    this.setState({basichttp: !basichttp})
  }

	render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    if (!is_logged_on()) {
      return (
        <Loading />
      )
    }

    if ( this.props.mustRedirect ) {
      // if this is true, fetching has succeeded
      const feed_id = this.props.feed.id
      return <Redirect to={`/projects/${feed_id}`} />
    }

    const auth_toggle = (
      <div className="section">
        <div className="switch">
          <label htmlFor="basehttp">
            HTTP Authentication Off
            <input id="basehttp" type="checkbox" onChange={this.toggleBasicHttp.bind(this)}/>
            <span className="lever"></span>
            On
          </label>
        </div>
      </div>
    )

    let auth_fields = ''
    if (this.state.basichttp) {
      auth_fields = (
        <React.Fragment>
          <div className="section">
            <div className="input-field">
              <label htmlFor="theuser" >Username for HTTP Authentication</label>
              <Control.text id="theuser" model= "newProject.http_user" />
            </div>
          </div>
          <div className="section">
            <div className="input-field">
              <label htmlFor="thepass" >Password for HTTP Authentication</label>
              <Control.text id="thepass" model= "newProject.http_pass" />
            </div>
          </div>
        </React.Fragment>
      )
    }

		return (
			<div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Add New Project</span>
					<i className="material-icons right">settings_input_composite</i>
				</div>

				<LocalForm
					className="collection-item"
					model="newProject"
          initialState={{
            feed_type: "xml",
            field_delimiter: "\\t"
          }}
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          onUpdate={this.handleUpdate.bind(this)}
					onSubmit={this.handleSubmit.bind(this)}
				>

          <div className="section">
            <div className="scriptFlex">
              <div className="mr-10">
                <label >Select Project Type</label>
              </div>
              <div className="mr-10">
                <label>
                  <Control.radio model="newProject.feed_type" className="with-gap" value="xml" />
                  <span>XML</span>
                </label>
              </div>
              <div className="mr-10">
                <label>
                  <Control.radio model="newProject.feed_type" className="with-gap" value="text" />
                  <span>TEXT (URL)</span>
                </label>
              </div>
              <div className="mr-10">
                <label>
                  <Control.radio model="newProject.feed_type" className="with-gap" value="textfile" />
                  <span>TEXT (FILE)</span>
                </label>
              </div>
              <div className="mr-10">
                <label>
                  <Control.radio model="newProject.feed_type" className="with-gap" value="excelfile" />
                  <span>EXCEL (FILE)</span>
                </label>
              </div>
            </div>
          </div>

					<div className="section">
						<div className="input-field">
							<label htmlFor="thename" >At first give a name to your Project</label>
							<Control.text id="thename" model= "newProject.name" required/>
						</div>
					</div>

          {
            (this.state.feed_type !== 'textfile' && this.state.feed_type !== 'excelfile') ? (
                <div className="section">
                  <div className="input-field">
                    <label htmlFor="theurl">Then give the feed url</label>
                    <Control.text id="theurl" model= "newProject.url" required/>
                  </div>
                </div>
            ) : (
              <div className="section">
                <div>
                  {
                    this.state.feed_type === 'textfile' ? (
                      <label htmlFor="theurl">Select Text File (Tab Separated Values)</label>
                    ) : (
                      <label htmlFor="theurl">Select Spreadsheet (xls, xlsx, xlsm, ods)</label>
                    )
                  }
                </div>
                <div>
                  <a className="btn mr-10" href='' onClick={e=>{
                    e.preventDefault()
                    document.getElementById('newProjectFile').click()
                  }}>FILE...</a>
                  <span style={{color:'#9e9e9e'}}>{this.state.feed_file}</span>
                  <Control.file id="newProjectFile" model="newProject.file" className="hide" onChange={this.handleChangeFile.bind(this)}/>
                </div>
              </div>
            )
          }


          {
            (this.state.feed_type !== 'xml') && (
              <React.Fragment>
                <div className="section">
                  <div className="input-field">
                    <label htmlFor="thetitle">Give the title for the optimized XML feeds</label>
                    <Control.text id="thetitle" model= "newProject.title" required/>
                  </div>
                </div>

                <div className="section">
                  <div className="input-field">
                    <label htmlFor="thedescription">Give the description for the optimized XML feeds</label>
                    <Control.text id="thedescription" model= "newProject.description" required/>
                  </div>
                </div>

                <div className="section">
                  <div className="input-field">
                    <label htmlFor="thelink">Give the URL advertised in the optimized XML feeds</label>
                    <Control.text id="thelink" model= "newProject.link" required/>
                  </div>
                </div>
              </React.Fragment>
            )
          }
          
          {
            (this.state.feed_type === 'textfile' || this.state.feed_type === 'text') && (
              <div className="section" style={
                (this.state.feed_type !== 'textfile' && this.state.feed_type !== 'text') ?
                { display: 'none' } :
                {}
              }>
                <div className="input-field">
                  <label className="active" htmlFor="field_delimiter">Give the field delimiter ('\t' for TSV, ',' for CSV, etc.)</label>
                  <Control.text id="thefield_delimiter" model= "newProject.field_delimiter" required/>
                </div>
              </div>
            )
          }

          {
            this.state.feed_type !== 'textfile' && this.state.feed_type !== 'excelfile' && (
              <React.Fragment>
                {auth_toggle}
                {auth_fields}
              </React.Fragment>
            )
          }

					<div className="section">
						<button type="submit" className="btn red darken-1 waves-effect waves-light">Next <i className="material-icons right">navigate_next</i></button>
					</div>
				</LocalForm>
        <Errors errors={this.props.errors}/>

			</div>
		)
	}
}

const NewProject = connect(mapStateToProps, mapDispatchToProps)(ConnectedNewProject);

export default NewProject;



// WEBPACK FOOTER //
// ./src/js/components/NewProject.js